import { BlockModel } from '../../../Common/PageBuilder/models/block.model';
import { BriefingBlockTypeEnum } from '../enums/briefing-block-type.enum';
import { BriefingModel } from '../models/briefing.model';
import { LayoutBlock } from '../../../Common/PageBuilder/models/layout-block.model';


export class BriefingsHelper {

    /**
     * return chart blocks in a briefing
     */
    static getChartBlocks(briefing: BriefingModel): BlockModel[] {
        if (!briefing) {
            return [];
        }

        const blocks = [];
        briefing.blocks.forEach(block => {
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        if (x.type.key === BriefingBlockTypeEnum.CHART) {
                            blocks.push(x);
                        }
                    });
                });
            } else {
                if (block.type.key === BriefingBlockTypeEnum.CHART) {
                    blocks.push(block);
                }
            }
        });

        return blocks;
    }
}
